import { styled } from '@mui/material';

export const ToolTipText = styled('span')`
  display: inline-block;
  text-decoration: underline;
  font-style: italic;
  cursor: help;
`;
